// Models
import { FormFieldSchema, FormFieldArraySchema } from 'app/shared/models/form';

// Components
import { U21FormFieldTypes } from 'app/shared/u21-ui/components';

// Utils
import { required } from 'app/shared/utils/validation';

// Constants
import { PartyNameTypeCode } from 'app/modules/fincenCtr/enums';

// Shared Input
export const PARTY_NAME_TYPE_CODE_INPUT: FormFieldSchema<PartyNameTypeCode> = {
  label: 'Name type',
  name: 'partyNameTypeCode',
  required: true,
  type: U21FormFieldTypes.RADIO_GROUP,
  default: PartyNameTypeCode.LEGAL,
};

export const RAW_PARTY_FULL_NAME_INPUT: FormFieldSchema<string> = {
  label: 'Full name',
  name: 'rawPartyFullName',
  required: true,
  validate: (value) => validateRawPartyLegalName(value),
  type: U21FormFieldTypes.TEXT,
};

export const ENTITY_LAST_NAME_UNKNOWN_INDICATOR_INPUT: FormFieldSchema<boolean> =
  {
    label: 'Unknown last name',
    name: 'entityLastNameUnknownIndicator',
    type: U21FormFieldTypes.CHECKBOX,
    default: false,
  };

export const FIRST_NAME_UNKNOWN_INDICATOR_INPUT: FormFieldSchema<boolean> = {
  label: 'Unknown first name',
  name: 'firstNameUnknownIndicator',
  type: U21FormFieldTypes.CHECKBOX,
  default: false,
};

export const RAW_ENTITY_INDIVIDUAL_LAST_NAME_INPUT: FormFieldSchema<string> = {
  label: 'Last name',
  name: 'rawEntityIndividualLastName',
  type: U21FormFieldTypes.TEXT,
  validate: (value) => validateRawPartyLegalName(value),
};

export const RAW_INDIVIDUAL_FIRST_NAME_INPUT: FormFieldSchema<string> = {
  label: 'First name',
  name: 'rawIndividualFirstName',
  type: U21FormFieldTypes.TEXT,
};

export const RAW_INDIVIDUAL_MIDDLE_NAME_INPUT: FormFieldSchema<string> = {
  label: 'Middle name',
  name: 'rawIndividualMiddleName',
  type: U21FormFieldTypes.TEXT,
};

export const RAW_INDIVIDUAL_NAME_SUFFIX_INPUT: FormFieldSchema<string> = {
  label: 'Suffix',
  name: 'rawIndividualNameSuffixText',
  type: U21FormFieldTypes.TEXT,
};

//  ==== Schemas ====
// This is used by Parties of type: 35, 37, 30, 8, 34
export const INSTITUTION_PARTY_NAME_SCHEMA: FormFieldSchema<any>[] = [
  PARTY_NAME_TYPE_CODE_INPUT,
  RAW_PARTY_FULL_NAME_INPUT,
];

// This is used by Parties of type: 50, 17, 23, 58
export const PERSON_PARTY_NAME_SCHEMA: FormFieldSchema<any>[] = [
  PARTY_NAME_TYPE_CODE_INPUT,
  ENTITY_LAST_NAME_UNKNOWN_INDICATOR_INPUT,
  RAW_ENTITY_INDIVIDUAL_LAST_NAME_INPUT,
  FIRST_NAME_UNKNOWN_INDICATOR_INPUT,
  RAW_INDIVIDUAL_FIRST_NAME_INPUT,
  RAW_INDIVIDUAL_MIDDLE_NAME_INPUT,
  RAW_INDIVIDUAL_NAME_SUFFIX_INPUT,
];

// Base schema for all parties, fields should be populated by each Party
export const PARTY_NAME_ARRAY_SCHEMA: FormFieldArraySchema<any> = {
  name: 'partyName',
  label: 'Name',
  type: 'ARRAY',
  fields: [],
};

const validateRawPartyLegalName = (value?: string) => {
  const mandatory = required('Required')(value);
  if (mandatory) {
    return mandatory;
  }
  if (value && value.length > 150) {
    return 'Max 150 characters allowed';
  }
  return undefined;
};
